export class Ruta_Sucursal {
   constructor(nombre_ruta, nombre_sucursal, direccion, colonia, poblacion, estado, cp, telefono_1, telefono_2){
      this.nombre_ruta = nombre_ruta
      this.nombre_sucursal = nombre_sucursal
      this.direccion = direccion
      this.colonia = colonia
      this.poblacion = poblacion
      this.estado = estado
      this.cp = cp
      this.telefono_1 = telefono_1
      this.telefono_2 = telefono_2

   }
   static fromServiceRutaSucursal (ruta_sucursal_info) {
      return new Ruta_Sucursal(
         ruta_sucursal_info.nombre_ruta,
         ruta_sucursal_info.nombre_sucursal,
         ruta_sucursal_info.direccion,
         ruta_sucursal_info.colonia,
         ruta_sucursal_info.poblacion,
         ruta_sucursal_info.estado,
         ruta_sucursal_info.cp,
         ruta_sucursal_info.telefono_1,
         ruta_sucursal_info.telefono_2
         );
   }   
}